import _ from "lodash";
import moment from "moment";
import { getRequest } from "NetworkCall";
import { INSTANCE_URL } from "Constants";

export const DEVICE_DATE_GRAPH = "DEVICE_DATE_GRAPH";
export const DEVICE_VERSION_GRAPH = "DEVICE_VERSION_GRAPH";

export const DASHBOARD_TOTAL_DEVICES = "DASHBOARD_TOTAL_DEVICES";

export function deviceInstalls(session, callback) {
  // debugger;
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/app_analytics?filter=(eventid=${session.eventid})AND(type='entry')AND(screen='overview')`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        // debugger;
        var data = response.resource;
        var modifiedData = [];
        modifiedData = _.sortBy(data, function (o) {
          return new moment(o.timestamp);
        });
        //Prepare data for Device Installs..
        var iosDevices = [];
        var androidDevices = [];
        var jsonArray = [];

        modifiedData.map((value, id) => {
          var strdata = value.data;
          var jsonData = JSON.parse(strdata);
          jsonArray.push({ ...jsonData, timestamp: value.timestamp });
        });

        var deviceIds = _.uniqBy(jsonArray, "device");

        dispatch({
          type: DASHBOARD_TOTAL_DEVICES,
          payload: { response: deviceIds, count: deviceIds.length },
        });

        callback({ error: 0, data: "Analytics Data Fetched" });
      },
      (error) => {
        callback({ error: 1, data: null });
      }
    );
  };
}

export function deviceInstallsNew(session, callback) {
  // debugger;
  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support?type=deviceInstalls&eventid=${session.eventid}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        // debugger;
        var data = response.resource;

        var modifiedData = [];
        modifiedData = _.sortBy(data, function (o) {
          return new moment(o.timestamp);
        });

        //Prepare data for Device Installs..
        var iosDevices = [];
        var androidDevices = [];
        var jsonArray = [];

        modifiedData.map((value, id) => {
          var strdata = value.data;

          strdata = strdata.replace('")', ")");
          var jsonData = JSON.parse(strdata);
          jsonArray.push({ ...jsonData, timestamp: value.timestamp });
        });

        /* 
         dpk mm (tue 26 july 2022) - Unique device means ? and in description there is nothing mentioned as unique. it should be the total device count.
        */
        var deviceIds = _.uniqBy(jsonArray, "device");

        dispatch({
          type: DASHBOARD_TOTAL_DEVICES,
          payload: { response: jsonArray, count: jsonArray.length },
          // Old code - payload: { response: deviceIds, count: deviceIds.length },
        });

        callback({ error: 0, data: "Device Installs Data Fetched" });
      },
      (error) => {
        callback({ error: 1, data: null });
      }
    );
  };
}

export function getDeviceInstalls(session) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/signaldevices?filter=eventid=${session.eventid}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        var ds = _.reject(response.resource, (d) => d.devicetype === "");
        var modifiedData = [];
        ds.map((data) => {
          modifiedData.push({
            ...data,
            createdon: moment(data.createdon).format("D MMM"),
          });
        });
        modifiedData = _.sortBy(modifiedData, function (o) {
          return new moment(o.createdon);
        });
        var dates = _.uniq(_.map(modifiedData, "createdon"));
        var devices = _.uniq(_.map(modifiedData, "devicetype"));
        var data = _.map(modifiedData, (d) => ({
          createdon: d.createdon,
          type: d.devicetype,
          version: d.deviceversion,
        }));

        var array = _.groupBy(data, "createdon");

        var newData = [];

        /*_.map(array, (obj)=>{
          _.mapKeys(obj,(val,key)=>{
              var iosdevices=_.filter(val,(deviceObj)=>deviceObj.type==='ios');
              var androiddevices=_.filter(val,(deviceObj)=>deviceObj.type==='android');
              newData.push({name:key,ios:iosdevices.length,android:androiddevices.length});
          });
      });*/

        var keys = _.keys(array);

        _.map(keys, (key) => {
          var arr = array[key];

          var iosdevices = _.filter(
            arr,
            (deviceObj) => deviceObj.type === "ios"
          );
          var androiddevices = _.filter(
            arr,
            (deviceObj) => deviceObj.type === "android"
          );
          newData.push({
            name: key,
            ios: iosdevices.length,
            android: androiddevices.length,
          });
        });

        /*var d = _.mapValues(_.mapKeys(_.map(devices, device => ({
        device, data: _.map(dates, date => (
          {name:date,devices: _.filter(data, {type: device, createdon: date}).length}
        ))
      })), 'device'), obj => obj.data);*/

        dispatch({ type: DEVICE_DATE_GRAPH, payload: newData });

        var versions = _.mapValues(
          _.mapKeys(
            _.map(devices, (device) => ({
              device,
              data: _.uniq(
                _.map(_.filter(ds, { devicetype: device }), "deviceversion")
              ),
            })),
            "device"
          ),
          (obj) => obj.data
        );

        var dd = _.mapValues(
          _.mapKeys(
            _.map(devices, (device) => ({
              device,
              data: _.map(versions[device], (version) => ({
                [version]: _.filter(data, { type: device, version: version })
                  .length,
              })),
            })),
            "device"
          ),
          (obj) => obj.data
        );

        dispatch({ type: DEVICE_VERSION_GRAPH, payload: dd });
      },
      (error) => {}
    );
  };
}
